import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AppFacadeService } from '../../../services/app-facade.service';
import { CPEnvironment } from '../../../models';
import { ConsumerPortalEnviromentConfig } from '../../../models/environment-consumer-portal';

@Component({
    standalone: false,
    selector: 'por-multipayment',
    templateUrl: './por-multipayment.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PorMultipaymentComponent {
    readonly appFacadeService = inject(AppFacadeService);
    private readonly appConfig = inject<ConsumerPortalEnviromentConfig>(CPEnvironment);

    porPayURL = this.appConfig.porPayScriptURL;
}
